let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jCNq4")).then(() => parcelRequire('8cY1n'));